module.exports = __webpack_public_path__ + "img/clipboard-medical.a4f5fb6f.svg";